module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/bg-pattern-bb08b6df73cd7273bdd8bb4d075d472f.svg";